import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { docAndSectorizationDTO } from '../models/docAndSectorizationDTO';
import { CalculationsService } from './calculations.service';
import { EndpointsService } from './endpoints.service';
import { ModalControlService } from './modal-control.service';
import { PointsService } from 'src/app/services/points.service';
import VectorSource from 'ol/source/Vector';
import { CoordenateService } from './coordenate.service';
import { ConfigurationService } from './configuration.service';
import { CalculationSettingsModel, ConfigurationModel, ConfigurationRCSModel, RNAVModel } from '../models/configuration';
import GeoJSON from 'ol/format/GeoJSON';
import { CalculationModel } from '../models/calculations';
import { MapService } from './map.service';
import { Fill, Stroke, Style, Text } from 'ol/style';
import { Collection, Feature } from 'ol';
import Geometry from 'ol/geom/Geometry';
import { TopLevelLayers } from '../menu/view-menu/top-level-layers';
import { ModalConfirmationService } from './modal-confirmation.service';
import { VectorLayerDMTR } from '../menu/view-menu/layer';
import { ProjectService } from './project.service';
import { PendingCalculation, PendingCalculationType } from '../models/pendingCalculation';
import { NavaidDTOCalculation } from '../models/navaid';
import { FeatureType } from '../models/EnumTypes';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocSectorizationDisplayService {

  activeRCS: ConfigurationRCSModel;
  pointsService : PointsService;

  constructor(private http: HttpClient,
    private endpointController : EndpointsService,
    public modalService : ModalControlService,
    private modalConfirmation : ModalConfirmationService,
    private pointService : PointsService,
    private rcsControl: CoordenateService,
    private configControl : ConfigurationService,
    public projectController : ProjectService,
    public mapService : MapService,
    public calculationService: CalculationsService,
    private configurationController: ConfigurationService
    ) {
      this.pointsService = pointService;
      
  }
  

  async rcsInit() {
    let activeConfiguration = this.configControl.currentConfiguration;
    if (!activeConfiguration) {
      activeConfiguration = await lastValueFrom(this.configControl.getActiveConfiguration());
    }
    ConfigurationModel.map(activeConfiguration).rcs.forEach(rcs => {
      if (rcs.active) {
        this.activeRCS = rcs;
      }
    });
  }

    calculateDocSectorizationDisplayInitialization(){
      const navaidsFeaturesSelected = this.pointService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid);
      const pendingCalculation: PendingCalculation = new PendingCalculation();
      pendingCalculation.selectedFeatures = navaidsFeaturesSelected;
      pendingCalculation.calculationType = PendingCalculationType.DOC_AND_SEC;
      this.pointService.getNavaidFeatureElevationMetersBulkInitialization(navaidsFeaturesSelected, pendingCalculation);
    }
  
  resumeCalculateDocSectorizationDisplay(navaidsFeaturesSelected: Feature<Geometry>[], navaidsEffectiveHeight: number[], navaidsTerrainHeight: number[]){
      if (!navaidsEffectiveHeight || navaidsEffectiveHeight.length != navaidsFeaturesSelected.length){
        this.modalService.showMesssageModal(
          `Calculation unsuccessful - Terrain Height`,
          `The was an error while performing the calculation: Terrain Height. Please confirm all the data and try again.`
        );
        return;
      }
      const navaids = [];
      for (let i = 0; i<navaidsFeaturesSelected.length; i++) {
        let dtoCalculation: NavaidDTOCalculation = new NavaidDTOCalculation();
        dtoCalculation = this.pointService.transformFeatureInNavaidCalculationDTO(navaidsFeaturesSelected[i]);
        dtoCalculation.effectiveHeight = navaidsEffectiveHeight[i];
        navaids.push(dtoCalculation);
      }
      if (navaidsFeaturesSelected.length >= 1) {
        let preparedNavaids: NavaidDTOCalculation[] = this.prepareNavAids(navaids);
        if (preparedNavaids.length == 0) {
          this.modalService.showMesssageModal(
            'Unable to Display Results',
            'No NavAids with DOC were selected.\nIn order to diplay results selected NavAids must have a defined DOC.'
          );
        } else {
          let docAndSectDTO: docAndSectorizationDTO = new docAndSectorizationDTO();
          docAndSectDTO.calculationSettings = CalculationSettingsModel.mapToCalculation(this.configurationController.currentConfiguration);
          docAndSectDTO.rnav = RNAVModel.mapToCalculation(this.configurationController.currentConfiguration.rnav);;
          docAndSectDTO.navaids = preparedNavaids;
          docAndSectDTO.projectId = this.configurationController.currentConfiguration.projectId;
  
          this.calculateDocAndSectorizationDisplay(docAndSectDTO);
        }
      }
    }

    prepareNavAids(navAidDBList: NavaidDTOCalculation[]): NavaidDTOCalculation[] {
      let navAidList: NavaidDTOCalculation[] = [];
  
      navAidDBList.forEach(nav => {
        if (nav.doc == null) {
          return;
        } else {
          nav.elevation = this.configurationController.currentConfiguration.defaultAltitudes.maxAltitudeFT;
          if (nav.maxaltitude == null) {
            nav.maxaltitude = this.configurationController.currentConfiguration.defaultAltitudes.maxAltitudeFT;
          }
        }
        navAidList.push(nav);
  
  
      });
      return navAidDBList;
    }
     


    calculateDocAndSectorizationDisplay(docAndSectorization: docAndSectorizationDTO) {
      let name = "Doc and Sectorizations - " + docAndSectorization.navaids.length + " NavAid";
      docAndSectorization.name = name;
      docAndSectorization.projectId = this.projectController.activeProject.id;
      this.http.post(
          this.endpointController.docAndSectorizationUrl,
          docAndSectorization,
          this.endpointController.httpOptions
        )
        .subscribe(
          {
            error: (error) => this.calculationService.showError(error)
          }
        );
      return new Array<string>();
    }

  showGeoJSON(
    data: CalculationModel,
    showMessage: boolean,
    calcName: string,
    id: number
  ) {
    let navaids_info = new Map<string, String[]>();
    let layers = [];
    let i = 0;

    data.results.forEach(result => {
      let navaid: string = JSON.parse(result.result).features[0].properties.NA;
      let elev: string = JSON.parse(result.result).features[0].properties.ELEV;

      if(navaids_info.has(navaid)){
        if(!navaids_info.get(navaid).includes(elev)){
          let list:String[] = navaids_info.get(navaid);
          list.push(elev);
          navaids_info.set(navaid, list);
        }
      }else{
        let list:String[] = [];
        list.push(elev)
        navaids_info.set(navaid, list);
      }
    });

    data.results.forEach(result => {
      var vectorSource = new VectorSource({
        features: new GeoJSON().readFeatures(result.result, {
          featureProjection: this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
          dataProjection: 'CRS:84',
        }),
        format: new GeoJSON({
          featureProjection: this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
          dataProjection: 'CRS:84',
        }),
      });

      let list : String[] = navaids_info.get(vectorSource.getFeatures()[0].getProperties().NA);
      let index:number = list.findIndex(x => x === vectorSource.getFeatures()[0].getProperties().ELEV);
      if (vectorSource.getFeatures().length > 0) {
        let elevation = vectorSource.getFeatures()[0].getProperties()['ELEV'];
        let layerName = elevation;
        let isRedundacy = true;

        if(index == list.length - 1){
          vectorSource.getFeatures().forEach((feat) => {
            let style = new Style({
              stroke: new Stroke({
                color: 'rgba(0,191,255)',
              }),
              text: new Text({
                font: '12px Calibri,sans-serif',
                overflow: true,
                offsetX: 50,
                offsetY: 3,
                rotateWithView: true,
                fill: new Fill({
                    color: 'rgba(0,191,255)'
                }),
              })
            });
            let elev: string = feat.getProperties().ELEV + '';
            style.getText().setText(elev);
            feat.setStyle(style);
          });
        }else {
          vectorSource.getFeatures().forEach((feat) => {
            let style = new Style({
              stroke: new Stroke({
                color: 'rgba(15,10,222)',
              }),
              text: new Text({
                font: '12px Calibri,sans-serif',
                overflow: true,
                offsetX: 0,
                offsetY: 7,
                rotateWithView: true,
                fill: new Fill({
                    color: 'rgba(15,10,222)'
                }),
              })
            });
            let elev: string = feat.getProperties().ELEV + '';
            style.getText().setText(elev);
            feat.setStyle(style);
          });
        }
        i++;
        var currentTimeInMilliseconds = Date.now(); // unix timestamp in milliseconds

        var appLayer = new VectorLayerDMTR({
          source: vectorSource,
        });
        appLayer.setVisible(true);

        //this.mapService.getMap('map').addLayer(appLayer);
        var layerObject = {
          id: layerName + currentTimeInMilliseconds,
          name: layerName,
          image: '',
          visible: isRedundacy,
          olLayer: appLayer,
        };
        layers.push(layerObject);
      }
    })

    let topLayer: TopLevelLayers =  new TopLevelLayers(
      true,
      calcName,
      layers,
      this.mapService.getMap('map'),
      this.modalConfirmation,
      null,
      this,
      id
    );

    topLayer.type ="DocAndSectorizationDisplay";
    topLayer.navaids_info = navaids_info;

    this.pointService
      .getCalculationsLayer()
      .childLayers.push(topLayer);

    if (showMessage) {
      this.modalService.showMesssageModal(
        'Calculation successful',
        'The Doc and Sectorization calculation was successful.'
      );
      this.fillCalculationsID();
    }
  }


  fillCalculationsID() {
    let result = this.http.get<CalculationModel[]>(
      this.endpointController.previousCalculations + '/' + this.projectController.activeProject.id,
      this.endpointController.httpOptions
    );
    let varthis = this;


    result.subscribe((calculations) =>
      calculations.forEach(function (calculation) {
        if (
          varthis.pointsService
            .getCalculationsLayer()
            .childLayers.findIndex((x) => x.calcID == calculation.id) < 0
        ) {
          let index = varthis.pointsService
            .getCalculationsLayer()
            .childLayers.findIndex((x) => x.calcID == -1);
            if (index != -1){
              varthis.pointsService.getCalculationsLayer().childLayers[
                index
              ].calcID = calculation.id;
            }

        }
      })
    );
  }

  deleteCalculation(calcID: number) {
    this.http
      .post(
        this.endpointController.deleteCalculation,
        calcID,
        this.endpointController.httpOptions
      )
      .subscribe(
        (data) => this.removeLayers(calcID),
        (error) => this.calculationService.showError(error)
      );
    return new Array<string>();
  }
  removeLayers(calcID: number) {
    let index = this.pointsService
    .getCalculationsLayer()
      .childLayers.findIndex((x) => x.calcID == calcID);

      this.pointsService
      .getCalculationsLayer()
      .childLayers[index].removeFromMap();

      this.pointsService
      .getCalculationsLayer().childLayers.splice(index, 1);
  }

}
